import React from 'react';
import TechFeatures from './TechFeatures';

// The "4 Simple Steps" narrative and its CTA were folded into TechFeatures'
// "How Author Voice DNA Works" section (founder-directed 2026-09-18, CT-26709)
// to remove duplicate copy between the two homepage sections.
const ProductIntro = () => <TechFeatures />;

export default ProductIntro;